<template>
  <AppToastCard
    variant="error"
    data-locator="redact-by-ai-error-message"
    :width="380"
  >
    <div class="d-flex">
      <app-icon-ds
        icon="fa-diamond-exclamation"
        size="xs"
        weight="fs"
        class="mr-2 mt-1 text-white"
      />
      <p class="ma-0 toast-text">
        {{ $t(searchByAiErrorKey) }}
      </p>
    </div>
  </AppToastCard>
</template>

<script setup lang="ts">
import { computed, watch, onBeforeUnmount } from 'vue'

import AppToastCard from '@/common/AppToastCard.vue'

const props = defineProps<{
  searchByAIError: any
  durationMs?: number
}>()

type Emits = (e: 'close') => void
const emit = defineEmits<Emits>()

const duration = computed(() => props.durationMs ?? 6000)

const searchByAiErrorKey = computed(() => {
  const err = props.searchByAIError
  const code = err?.code || err?.response?.data?.code || null

  const errorKeyPrefix = 'common.PdfRedactingSidebar.searchByAi.error'
  if (code === 'ERROR_AFTER_CHUNKS') return `${errorKeyPrefix}.errorAfterChunks`
  return `${errorKeyPrefix}.serviceDown`
})

let timer: ReturnType<typeof globalThis.setTimeout> | null = null

function clearTimer () {
  if (timer !== null) {
    globalThis.clearTimeout(timer)
    timer = null
  }
}

function startTimer () {
  clearTimer()
  timer = globalThis.setTimeout(() => emit('close'), duration.value)
}

// Restart timer when error changes
watch(
  () => props.searchByAIError,
  (val) => { if (val) startTimer() },
  { immediate: true },
)

onBeforeUnmount(clearTimer)
</script>

<style scoped lang="scss">
.toast-text {
  color: white;
  font-weight: 400;
  overflow-wrap: anywhere;
}
</style>
